var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c('h1',{staticClass:"pb-2"},[_vm._v("\n    "+_vm._s(_vm.$t('Flow Chart'))+"\n  ")]),_vm._v(" "),_c('p')])}
var staticRenderFns = []

export { render, staticRenderFns }